export default __webpack_public_path__ + "static/media/roboto-v20-latin-700italic.a86f4762.ttf";